import React, { createContext, useState, useMemo, useEffect } from 'react'
import { lightTheme, darkTheme } from '../themes.js'

const ThemeContext = createContext()

const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const storedValue = localStorage.getItem('isDarkMode')
    return storedValue !== null ? JSON.parse(storedValue) : true
  })

  useEffect(() => {
    localStorage.setItem('isDarkMode', JSON.stringify(isDarkMode))
  }, [isDarkMode])

  useEffect(() => {
    document.body.classList.toggle('theme-dark', isDarkMode)
    document.body.classList.toggle('theme-light', !isDarkMode)
  }, [isDarkMode])

  const theme = useMemo(() => {
    return isDarkMode ? darkTheme : lightTheme
  }, [isDarkMode])

  const value = {
    theme,
    isDarkMode,
    setIsDarkMode
  }

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}

export { ThemeContext, ThemeProvider }
